import React from 'react';
import Confirmed from '../../components/Confirmed/Confirmed';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

export const Confimedbooking = () => {
    return (
        <>
            <Header />
            <Confirmed />
            <Footer />
        </>
    )
}